import React from "react";
import { Link } from "react-router-dom";

const Fertures = () => {


    return (
        <section className="" data-id="5b69dca" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}" style={{ left: '0px', marginTop: '-97px' }}>
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3cbdbb8" data-id="3cbdbb8" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-4eda1e5 elementor-widget elementor-widget-dc_element_custom_links" data-id="4eda1e5" data-element_type="widget" data-widget_type="dc_element_custom_links.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-slider dc-customlinksholder dc-haslayout dynamic-secton-396068">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div id="dc-doctorslider-396068" className="dc-doctorslider owl-carousel dc-doctorslider-396068 owl-loaded owl-drag">


                                                <div className="owl-stage-outer">
                                                    <div className="owl-stage" style={{ transform: 'translate3d(0px, 0px, 0px)', transition: 'all', width: '100%', display: 'flex', overflowY: 'scroll' }}>
                                                        <div className="owl-item active">
                                                            <div className="item dc-doctordetails-holder dc-titlecolor1">
                                                                <span className="dc-slidercounter">
                                                                    <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/10/3.png" alt="links" />
                                                                </span>
                                                                <h3>
                                                                    <span>Live Chat With</span>
                                                                    Doctors
                                                                </h3>
                                                                <Link to="/search-hospitals" className="dc-btn">Click Here</Link>
                                                            </div>
                                                        </div>
                                                        <div className="owl-item active">
                                                            <div className="item dc-doctordetails-holder dc-titlecolor2">
                                                                <span className="dc-slidercounter">
                                                                    <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/10/2.png" alt="links" />
                                                                </span>
                                                                <h3>
                                                                    <span>Fast Appointment With</span>
                                                                    Nearest Hospital
                                                                </h3>
                                                                <Link to="/search-hospitals" className="dc-btn">Click Here</Link>
                                                            </div>
                                                        </div>
                                                        <div className="owl-item active">
                                                            <div className="item dc-doctordetails-holder dc-titlecolor3">
                                                                <span className="dc-slidercounter">
                                                                    <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/10/1.png" alt="links" />
                                                                </span>
                                                                <h3>
                                                                    <span>Articles From Top</span>
                                                                    Hospitals &amp; Doctors
                                                                </h3>
                                                                <Link to="/articles" className="dc-btn">Click Here</Link>
                                                            </div>
                                                        </div>
                                                        <div className="owl-item active" >
                                                            <div className="item dc-doctordetails-holder dc-titlecolor4">
                                                                <span className="dc-slidercounter">
                                                                    <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/10/4.png" alt="links" />
                                                                </span>
                                                                <h3>
                                                                    <span>Our 24/7 Active</span>
                                                                    Help Support
                                                                </h3>
                                                                <Link to="/contact-us" className="dc-btn">Click Here</Link>
                                                            </div>
                                                        </div>
                                                        <div className="owl-item active" >
                                                            <div className="item dc-doctordetails-holder dc-titlecolor5">
                                                                <span className="dc-slidercounter">
                                                                    <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/10/5.png" alt="links" />
                                                                </span>
                                                                <h3>
                                                                    <span>Help on The Go</span>
                                                                    Download App
                                                                </h3>
                                                                <Link to="/download-app" className="dc-btn">Click Here</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="owl-dots">
                                                    <div className="owl-dot active">
                                                        <span></span>
                                                    </div>
                                                    <div className="owl-dot">
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Fertures;
